/**
 * Which holdings the user may edit or delete (WP-CORE-11).
 *
 * The API decides: `isManual` is true only for holdings of a manual account.
 * Holdings synced from a bank (and any other non-manual account) are read-only,
 * and the API refuses PUT/DELETE on them with 403 `HOLDINGS_READ_ONLY`.
 * Balance-derived (synthetic) holdings are never editable either.
 *
 * Changing a holding's asset class (classification override) is a separate
 * action and stays available for every real holding, synced ones included.
 *
 * One rule for every place that offers Edit or Delete: do not re-derive it
 * from `holdingSource` or the account. Anything but an explicit
 * `isManual: true` is read-only.
 */
export interface HoldingEditFlags {
  isManual?: boolean;
  isSynthetic?: boolean;
}

export function canModifyHolding(holding: HoldingEditFlags): boolean {
  return holding.isManual === true && holding.isSynthetic !== true;
}
